import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import { Box, HStack, IconButton } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FiSearch, FiX } from 'react-icons/fi'

/**
 * Users Filters Component
 * Filtering controls for users list (superadmin only)
 */
export function UsersFilters({ filters, onFiltersChange, onReset }) {
  const { t } = useTranslation()
  // Local state for search input (submit on Enter only)
  const [searchValue, setSearchValue] = useState(filters.search || '')

  const handleChange = (field, value) => {
    onFiltersChange({ ...filters, [field]: value })
  }

  const handleSearchSubmit = () => {
    handleChange('search', searchValue)
  }

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit()
    }
  }

  const handleReset = () => {
    setSearchValue('')
    onReset()
  }

  return (
    <Box>
      <HStack spacing={4} flexWrap="wrap">
        {/* Search by name/username/email */}
        <HStack minW="250px" flex={1}>
          <Input
            placeholder={t('users.searchByNameUsernameEmail')}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={handleSearchKeyPress}
          />
          <IconButton
            aria-label="Search"
            onClick={handleSearchSubmit}
            variant="outline"
          >
            <Box as={FiSearch} />
          </IconButton>
        </HStack>

        {/* Status filter */}
        <Box minW="150px">
          <Select
            placeholder={t('users.allStatus')}
            value={filters.is_active || ''}
            onChange={(e) => handleChange('is_active', e.target.value)}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </Select>
        </Box>

        {/* Role filter */}
        <Box minW="160px">
          <Select
            placeholder={t('users.allRoles')}
            value={filters.role || ''}
            onChange={(e) => handleChange('role', e.target.value)}
          >
            <option value="superadmin">Superadmin</option>
            <option value="staff">Staff</option>
          </Select>
        </Box>

        {/* Reset button */}
        <Button
          variant="ghost"
          onClick={handleReset}
          disabled={!Object.values(filters).some((v) => v)}
        >
          <HStack spacing={2}>
            <Box as={FiX} />
            <span>Reset</span>
          </HStack>
        </Button>
      </HStack>
    </Box>
  )
}

export default UsersFilters
